import React, { Component } from "react";
import PropTypes from "prop-types";
import Card from "material-ui/Card";
import Tabs, { Tab } from "material-ui/Tabs";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { resetResults, changeModeTabs } from "../../modules/search";
import { changeEnableMap, handleMenuContextStyle } from "../../modules/map";
import HeaderCard from "./HeaderCard/HeaderCard";
import ItineraryForm from "./TabsCard/ItineraryForm/ItineraryForm";
import LoopForm from "./TabsCard/LoopForm/LoopForm";
import cities from "../../config/city";
import ExtendResult from "./ExtendResult/ExtendResult";
import InlineResult from "./InlineResult/InlineResult";

import "./MainCard.css";

class MainCard extends Component {
  constructor() {
    super();
    this.state = {
      value: 0,
      shouldOpenDialog: false
    };
  }

  componentWillMount() {
    const currentCity = cities.find(
      city =>
        city.name.toLowerCase() === this.props.city.toLowerCase().substring(1)
    );
    if (
      !currentCity ||
      (this.props.action !== "boucle" && this.props.action !== "itineraire")
    ) {
      this.props.goRoot();
    } else {
      this.props.changeEnableMap(true, currentCity);
      this.props.changeModeTabs(this.props.action);
      this.setState({
        value: this.props.action === "boucle" ? 1 : 0
      });
    }
  }

  handleChangeTab = (event, value) => {
    this.props.history.push(
      `/${this.props.city}/${value === 0 ? "itineraire" : "boucle"}`
    );
    this.props.resetResults();
    this.props.changeModeTabs(value === 0 ? "itineraire" : "boucle");
    this.setState({ value });
  };

  handleOpenInfoDialog = () => {
    this.setState({ shouldOpenDialog: true });
  };

  handleCloseInfoDialog = () => {
    this.setState({ shouldOpenDialog: false });
  };

  render() {
    return (
      <div
        onClick={() => this.props.handleMenuContextStyle("none", 0, 0, 0, 0)}
        className="main-card"
      >
        <Card>
          <HeaderCard
            isCity
            className="header-city"
            subtitle={this.props.city.substring(1)}
            openInfoDialog={this.handleOpenInfoDialog}
          />
          <div
            className={!this.props.menuIsOpen ? "no-display" : "content-card"}
          >
            <Tabs
              value={this.state.value}
              onChange={this.handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              fullWidth
            >
              <Tab label="ITINÉRAIRE" />
              <Tab label="BOUCLE" />
            </Tabs>
            <div className="tabs-container">
              {this.state.value === 0 && <ItineraryForm />}
              {this.state.value === 1 && <LoopForm />}
              {this.props.results.length > 0 &&
                this.props.mode === "extend" && <ExtendResult />}
              {this.props.results.length > 0 &&
                this.props.mode === "inline" && <InlineResult />}
            </div>
          </div>
        </Card>
      </div>
    );
  }
}
MainCard.propTypes = {
  goRoot: PropTypes.func.isRequired,
  city: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  history: PropTypes.shape().isRequired,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          time: PropTypes.number,
          distance: PropTypes.number,
          path: PropTypes.shape().isRequired
        })
      )
    })
  ).isRequired,
  resetResults: PropTypes.func.isRequired,
  changeEnableMap: PropTypes.func.isRequired,
  handleMenuContextStyle: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  menuIsOpen: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  city: ownProps.match.params.city,
  action: ownProps.match.params.action,
  results: state.search.results,
  mode: state.search.mode,
  menuIsOpen: state.search.menuIsOpen
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: (city, action) => push(`/${city}/${action}`),
      goRoot: () => push(`/`),
      resetResults,
      changeEnableMap,
      handleMenuContextStyle,
      changeModeTabs
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MainCard);



// WEBPACK FOOTER //
// ./src/containers/MainCard/MainCard.jsx